import Icon from "./IconBase.js";
const ArrowRightActiveIcon = (props) => (
  <Icon width="18" height="18" viewBox="0 0 18 22" {...props} fill="#A1AEB7">
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 13L7 7L1 1"
        stroke="#00b0f5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);
export default ArrowRightActiveIcon;
